import { DimensionUnitEnum } from 'api';

import { formatDimensionUnit } from '../../utils/formatDimensionUnit/formatDimensionUnit';
import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';

const DIMENSION_UNIT_OPTIONS =
  DimensionUnitEnum &&
  Object.values(DimensionUnitEnum).map((dimensionUnit: DimensionUnitEnum) => ({
    label: formatDimensionUnit(dimensionUnit),
    value: dimensionUnit,
  }));

type Props = Omit<SelectFieldProps, 'options'>;
export const DimensionUnitSelectField = (props: Props) => {
  return <SelectField options={DIMENSION_UNIT_OPTIONS} {...props} />;
};
